import React from "react"
import { onboarding_mismatched_sales_inventories_path } from "@/routes"

const MismatchedSalesButton = () => {
  const exportInventoryData = () => {
    window.open(onboarding_mismatched_sales_inventories_path(), "_blank").focus()
  }

  return (
    <button className="btn btn-secondary" onClick={exportInventoryData}>
      <span className="fas fa-arrow-right me-2" />
      Mismatched Sales
    </button>
  )
}
export default MismatchedSalesButton
